import { render, staticRenderFns } from "./ChangeGroupIdDialog.vue?vue&type=template&id=36042844&"
import script from "./ChangeGroupIdDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeGroupIdDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports